import { defineStore } from "pinia";

export const useStipsWeekStore = defineStore("stipsWeekStore", () => {

const { $apiAuth } = useNuxtApp()

async function getStipsWeeksWEB(year){
        try {
           const { data } = await useAPIStips(`/nedelje_za_godinu/${year}`,{
            method: 'GET',
            use: 'admin',
           });
      
        
            return {
              success: true,
              data: JSON.parse(data?.value).result.nedelje ,
            };

        } catch (error) {
  
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function createWeekByYear(items){
        try {
          const  data  = await $apiAuth(`/api/stips/week/create`,{
            method: 'POST',
            use: 'admin',
            body:{
              data: items 
            }
           })
           return {
              success: true,
              content: data?.data,
              errorValidation: {}
            };
   
        } catch (error) {

          return {
             success: false,
             status: error.response?.status,
             data: null,
             errorValidation: error?.response?._data?.errors
          };
        }
      }
async function updateStipsWeek(week) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/stips/week/update`,{
            method: 'PUT',
            use: 'admin',
            body:{
              ...week
            }
           })
           
            return {
              success: data?.success,
              data: data?.data,            
            };

        } catch (error) {

           
          return {
             success: false,
             status: error.response?.status,
             errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function deleteStipsWeek(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/stips/week/delete/${id}`,{
            method: 'DELETE',
            use: 'admin',
           })

            return {
              success: true,
              content: data?.success,
            };
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            content: null,
          };
        }
      }
      async function getStipsWeekPaginate(
    input
  ){
    try {
      const data = await useNuxtApp().$apiAuth('/api/stips/week/paginate',{
        method: 'GET',
        use: 'admin',
        params:{
          ...input
        }
       })
 

       return {
          success: true,
          data: data?.data,
        };
       
    } catch (error) {
       
       
       

      return {
        success: false,
        status: error.response?.status,
        data: null,
      };
    }
    
   }

   async function setCacheAllWeeksData(){
        try {
           const  data  = await useNuxtApp().$apiAuth('/api/stips/week/all/cache',{
                method: 'GET',
                use: 'admin',    
             })
        
            return {
              success: true,
              data: data?.data
            };

        } catch (error) {
  
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }

      async function getCacheAllWeeksData(){
        try {
           const  data  = await useNuxtApp().$apiAuth('/api/stips/week/all/get',{
                method: 'GET',
                use: 'admin'        
             })
        
            return {
              success: true,
              data: data?.data
            };

        } catch (error) {
  
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getCacheWeeksByYear(input){
        try {
           const  data  = await useNuxtApp().$apiAuth('/api/stips/week/by/year',{
                method: 'GET',
                use: 'admin',
                params:{
                  year: input.year
                }
        
             })
    
        
            return {
              success: true,
              data: data?.data
            };

        } catch (error) {
         
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
       async function getCacheWeeksByYearPublic(input){
        try {
           const  {data}  = await useNuxtApp().$apiAxios.get('/api/stips/week/by/year/public',{
                params:{
                  ...input
                }
        
             })   
            return {
              success: true,
              data: data?.data
            };

        } catch (error) {
         
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getCacheWeeksByYearAdPublic(input){
        try {
           const  {data}  = await useNuxtApp().$apiAxios.get('/api/stips/week/with/ad/public',{
                params:{
                  ...input
                }
        
             })   
            return {
              success: true,
              data: data?.data
            };

        } catch (error) {
          
         
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getCurrentWeek(){
        try {
           const  data  = await useNuxtApp().$apiAuth('/api/stips/week/current',{
                method: 'GET',
                use: 'admin',
             })
    
        
            return {
              success: true,
              data: data?.data
            };

        } catch (error) {
         
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getByCategoryWeek(item){
        try {
           const  { data }  = await useNuxtApp().$apiAxios.get('/api/stips/public/by/category/week',{
                params:{
                  ...item
                }
             })
    
        
            return {
              success: true,
              data: data?.data
            };

        } catch (error) {
       
         
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getByCategoryWeekExternal(item){
        try {
           const  { data }  = await useNuxtApp().$apiAxios.get('/api/stips/public/by/category/week/external',{
                params:{
                  ...item
                }
             })
    
        
            return {
              success: true,
              data: data?.data
            };

        } catch (error) {
       
         
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      return {
        getStipsWeeksWEB,
        createWeekByYear,
        updateStipsWeek,
        deleteStipsWeek,
        getStipsWeekPaginate,
        setCacheAllWeeksData,
        getCacheAllWeeksData,
        getCacheWeeksByYear,
        getCacheWeeksByYearPublic,
        getCacheWeeksByYearAdPublic,
        getCurrentWeek,
        getByCategoryWeek,
        getByCategoryWeekExternal
      }

})
